const users={
    "A4FJVY7":
    {
        "id":"A4FJVY7",
        "name":"Halim Uddin",
        "father's_name":"Naim Uddin",
        "mother's_name":"Halima Begum",
        "residence":"Dalim para, Kushtia, Myanmar",
        "imgUrl":"https://i.postimg.cc/xTqp2wNL/images.jpg"

    }
}
export default users